module.exports = __webpack_public_path__ + "562216815c0a093f3b2453c848287f64.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/redbull.svg
// module id = 53
// module chunks = 0